<template>
  <div class= "propertyCarManageList">
    <div class="filters">
      <el-form :inline="true" :model="form" ref="form">
        <el-form-item>
          <el-select @change="selectUnit" v-model="form.houseId">
            <el-option key :label="$t('lang.lab_selectHouse')" value=""></el-option>
            <el-option
              v-for="(item,index) in houses"
              :key="index"
              :value="item.id"
              :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select @change="selectRoom" v-model="form.unitId">
            <el-option key :label="$t('lang.lab_selectUnit')" value=""></el-option>
            <el-option
              v-for="(item,index) in units"
              :key="index"
              :value="item.id"
              :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.roomId">
            <el-option key :label="$t('lang.lab_selectRoom')" value=""></el-option>
            <el-option
              v-for="(item,index) in rooms"
              :key="index"
              :value="item.id"
              :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
    		<el-form-item :label="$t('lang.lab_Type')" size="mini"> 
					<el-select v-model="form.type">
						<el-option :label="$t('lang.lab_room')" :value="1"></el-option>
						<el-option :label="$t('lang.lab_carPlace')" :value="2"></el-option>
					</el-select>
				</el-form-item>
        <el-form-item>
          <el-input :placeholder="$t('lang.lab_parkingNumber')" v-model="form.carPlace"></el-input>
        </el-form-item>
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-table
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
      >
       
        <el-table-column type="selection" width="55" v-if="this.preHouseholdInfoManageListcheckbox"></el-table-column>
        <el-table-column type="index"align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
				<el-table-column
          prop="houseName"
          :label="$t('lang.lab_buildingnum')" >
        </el-table-column>
         <el-table-column
          prop="unitName"
          :label="$t('lang.lab_unitnum')" >
        </el-table-column>
         <el-table-column
          prop="roomName"
          :label="$t('lang.lab_roomnum')" >
        </el-table-column>
				 <el-table-column
          prop="placeName"
          :label="$t('lang.lab_parkingNumber')" v-if="typeCar===2">
        </el-table-column>
        <el-table-column
          prop="describe"
					width="510"
          :label="$t('lang.lab_describe')" >
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('lang.lab_otDoorDeviceSon')">
          <template slot-scope="scope">
            <span>{{scope.row.createTime | time}}</span>
          </template>
        </el-table-column>
				<el-table-column
          prop="idNo"
          :label="$t('lang.lab_operator')" >
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
/**
 *@ClassName:preHouseholdInfoManageList
 *@Description:车位数据管理
 */
export default {
 //name: '/manage/main.transferLogs',
  data() {
    return {
			propertyCarRow:{},
      multipleSelection: [], // 多选框
			type: 1,
      pageNo: 1, // 页数
      pageSize: 10, // 每页显示数量
      pageCount: 0, // 总页数
			typeCar: '',
      form: { 
        houseId: '', // 楼号
        unitId: '', // 单元号
        roomId: '', // 房间号 
        key: '', // 关键词
        id: '', // 序号
        carPlace: '',
				type:2
      },
      isImageFlag: '', // 判断是否选择文件，空为没有上传
      houses: [], //  存储根据小区请求回来的楼号
      units: [], //  存储根据楼号请求回来的单元
      rooms: [], //  存储根据单元请求回来的房间号
      tableData: [], // 列表数据
      uploadFile: '',
      fileList: [], // 上传
      fjTypes: this.$i18n.t('lang.fjTypes'), // 下拉列表
      preHouseholdInfoManageListcheckbox: require('@/config/enum').preHouseholdInfoManageListcheckbox // 是否隐藏复选框
    }
  },
  created() {
		this.propertyCarRow = this.$route.query.propertyCar
		console.log(this.propertyCarRow)
		if(this.propertyCarRow!=undefined&&Object.keys(this.propertyCarRow).length>0){
				this.form.carPlace = this.propertyCarRow.PlaceName
				this.form.type = 2
		}
    setTimeout(() => {
       window.localStorage.setItem('editPreInfoForm', '')
       window.localStorage.setItem('editPreInfoSaveData', '')
    }, 200)
    this.selectHouse(this.gardenId)
    this.getData()
  },
  activated() {
    this.getData()
  },
  computed: {
      ...mapGetters(['gardenId'])
    },
  methods: {
    // 获取数据
    getData() {
      let loading = this.$loading()
      this.$get(`/transferLogs?pageNo=${this.pageNo}&pageSize=${this.pageSize}&gardenId=${this.gardenId}&houseId=${this.form.houseId}&unitId=${this.form.unitId}&roomId=${this.form.roomId}&carPlace=${this.form.carPlace}&type=${this.form.type}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
						if(this.form.type==2){
							this.typeCar=2
						}else{
							this.typeCar=1
						}
						
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // id查询楼号楼层房间号
    gardenGrids(type, id) {
      if (id === '') return
      this.$get(`/gardenGrids/?type=${this.type}&parentId=${id}&pageNo=1&pageSize=9999`).then(
        res => {
          if (res && res.errCode === 0) {
            if (this.type === 1) {
              this.houses = res.list
            } else if (this.type === 2) {
              this.units = res.list
            } else if (this.type === 3) {
              this.rooms = res.list
            }
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 根据小区选择获取楼号
    selectHouse(id) {
      this.type = 1
      this.form.houseId = ''
      this.form.unitId = ''
      this.form.roomId = ''
      this.houses = []
      this.units = []
      this.rooms = []
      this.gardenGrids(this.type, id)
    },
    // 根据楼号选择获取单元
    selectUnit(id) {
      this.type = 2
      this.form.unitId = ''
      this.form.roomId = ''
      this.units = []
      this.rooms = []
      this.gardenGrids(this.type, id)
    },
    // 根据单元选择获取房间
    selectRoom(id) {
      this.type = 3
      this.rooms = []
      this.form.roomId = ''
      this.gardenGrids(this.type, id)
    },
    // 查询
    commit() {
      this.pageNo = 1
      this.search()
    }, 
    // 筛选
    search() {
      let loading = this.$loading()
      this.$get(`/transferLogs?pageNo=${this.pageNo}&pageSize=${this.pageSize}&gardenId=${this.gardenId}&houseId=${this.form.houseId}&unitId=${this.form.unitId}&roomId=${this.form.roomId}&carPlace=${this.form.carPlace}&type=${this.form.type}`).then(
        res => {
          if (res && res.errCode === 0) {
            debugger
						if(this.form.type==2){
							this.typeCar=2
						}else{
							this.typeCar=1
						}
            loading.close()
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.search()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.search()
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    
  }
}
</script>

<style lang= 'scss'>

 .haveParentIdstyle {
      color: #0f07fc;
      cursor: pointer;
    }
</style>